import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { TFormQuestion } from '@onesource/services';

interface MultiSelectQuestionProps {
  question: TFormQuestion;
  selectedOptionIds: string[];
  onSelect: (optionIds: string[]) => void;
  disabled?: boolean;
}

export const MultiSelectQuestion = ({
  question,
  selectedOptionIds,
  onSelect,
  disabled = false,
}: MultiSelectQuestionProps) => {
  const handleChange = (optionId: string) => {
    if (selectedOptionIds.includes(optionId)) {
      onSelect(selectedOptionIds.filter(id => id !== optionId));
    } else {
      onSelect([...selectedOptionIds, optionId]);
    }
  };

  const sortedOptions = [...question.options].sort((a, b) => a.position - b.position);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {sortedOptions.map((option, _index) => {
        const isSelected = selectedOptionIds.includes(option.id);

        return (
          <Box
            key={option.id}
            onClick={() => !disabled && handleChange(option.id)}
            sx={{
              p: 2,
              bgcolor: 'white',
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1.5,
              cursor: disabled ? 'default' : 'pointer',
              transition: 'all 0.2s',
              border: '2px solid',
              borderColor: isSelected ? '#ff4d6d' : 'transparent',
              '&:hover': disabled
                ? {}
                : {
                    boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
                  },
            }}
          >
            <Box
              sx={{
                width: 20,
                height: 20,
                border: '2px solid',
                borderColor: isSelected ? '#ff4d6d' : '#ccc',
                borderRadius: '4px',
                bgcolor: isSelected ? '#ff4d6d' : 'white',
                flexShrink: 0,
                mt: 0.25,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {isSelected && (
                <Box
                  component="span"
                  sx={{
                    color: 'white',
                    fontSize: 14,
                    fontWeight: 'bold',
                    lineHeight: 1,
                  }}
                >
                  ✓
                </Box>
              )}
            </Box>

            <Typography sx={{ lineHeight: 1.5 }}>{option.optionText}</Typography>
          </Box>
        );
      })}
    </Box>
  );
};
